import { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';

import styles from './icons.module.scss';
import { assetsPath } from '../../../data/constants';
import { useIntl } from 'react-intl';
import { useDetermineLocale } from '@/hooks';
import { getRefillHref, getStoreOrFlyerHref } from '@/utils';

type IconData = {
  href: string;
  src: string;
  text: string;
  width: number;
  height: number;
};

const Icons: FC = () => {
  const { formatMessage } = useIntl();
  const locale = useDetermineLocale();

  const iconData: IconData[] = [
    {
      href: getRefillHref(locale),
      src: `${assetsPath}/site-icons/2020-site-icons/ico-prescriptions.svg`,
      text: 'refills',
      width: 17.341,
      height: 20.407,
    },
    {
      href: getStoreOrFlyerHref(locale, 'store-locator'),
      src: `${assetsPath}/site-icons/2020-site-icons/ico-stores.svg`,
      text: 'stores',
      width: 14,
      height: 16,
    },
    {
      href: getStoreOrFlyerHref(locale, 'flyer'),
      src: `${assetsPath}/site-icons/2020-site-icons/ico-flyer.svg`,
      text: 'flyer',
      width: 16,
      height: 15.93,
    },
  ];

  return (
    <div className={styles.iconsContainer}>
      {iconData.map(({ href, src, text, width, height }) => (
        <Link href={href} target="_blank" rel="noopener noreferrer" className={styles.icon} key={href}>
          <Image
            src={src}
            width={width}
            height={height}
            alt={formatMessage({ id: text })}
            style={{ maxWidth: 'inherit' }}
          />
          <span>{formatMessage({ id: text })}</span>
        </Link>
      ))}
    </div>
  );
};

export default Icons;
